@if (!loading) {
  <div class="container">
    <div class="tab-bar">
      @for (tab of getTabs(); track tab; let i = $index; let isLast = $last) {
        <div class="tab-item" [ngClass]="{'none' : tab.visible === false}">
          <h5 class="tab" [ngClass]="{'selected-tab' : i == selectedTabIndex, 'view-tab' : i == selectedViewIndex && i != selectedTabIndex, 'main-view-tab-hover' : i != selectedTabIndex && i != selectedViewIndex}" (click)="changeTab(i)">
            {{tab.title | uppercase}}
          </h5>
          @if (!isLast) {
            <div class="divider"></div>
          }
        </div>
      }
    </div>
    <div class="tab-bar">
      @for (subtitle of selectedSubTabs; track subtitle; let j = $index; let isLast = $last) {
        <div class="tab-item">
          <h6 class="tab"
              [ngClass]="{'selected-tab' : j == selectedSubTabIndex && selectedViewIndex == selectedTabIndex, 'view-tab-hover' : j != selectedSubTabIndex || selectedViewIndex != selectedTabIndex}"
              (click)="changeSubTab(j)">
            {{subtitle | uppercase}}
          </h6>
          @if (!isLast) {
            <div class="divider"></div>
          }
        </div>
      }
    </div>
  </div>
}
@if (loading) {
  <mat-progress-bar mode="indeterminate" class="loader"></mat-progress-bar>
}
